"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionBidForm = void 0;
const identity_reducer_1 = require("@app/store/reducers/identity.reducer");
const approve_hooks_1 = require("@hooks/contracts/approve.hooks");
const form_hooks_1 = require("@hooks/form.hooks");
const button_1 = require("@shared-modules/components/button");
const currency_input_1 = require("@shared-modules/components/currency-input");
const number_1 = require("@utils/object/number");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const React = __importStar(require("react"));
const helper_1 = require("./helper");
const auction_hooks_1 = require("@hooks/contracts/auction.hooks");
const block_tracker_hooks_1 = require("@hooks/block-tracker.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const react_1 = require("react");
const AuctionBidForm = (props) => {
    const { auction, updateToken, allowToBid } = props;
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.auctionBidForm");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const [isBiddingProcess, setIsBiddingProcess] = (0, react_1.useState)(false);
    const paymentTokenBalance = (0, approve_hooks_1.useTokenBalance)(auction.paymentTokenAddress);
    const { waitBlock } = (0, block_tracker_hooks_1.useBlockTracker)(() => {
        updateToken();
        setIsBiddingProcess(false);
    });
    const isIdentified = (0, identity_reducer_1.useInClaim)(identity_reducer_1.UserClaim.isIdentified);
    const [approvalState, approveCallback] = (0, approve_hooks_1.useApprove)(auction.paymentTokenAddress, auction.contractAddress);
    const sendBid = (0, auction_hooks_1.useBidding)(auction.tokenId, paymentTokenBalance, auction.contractAddress);
    const lastBid = auction.bids.sort((left, right) => new bignumber_js_1.default(right.amount).minus(left.amount).toNumber())[0];
    const { form, validationResults, fieldHandlers, submit: placeBid, } = (0, form_hooks_1.useForm)({
        initialData: { bid: "0" },
        validators: (0, helper_1.createValidators)((0, number_1.normalizeValue)((lastBid === null || lastBid === void 0 ? void 0 : lastBid.amount) || auction.minPrice, paymentTokenBalance === null || paymentTokenBalance === void 0 ? void 0 : paymentTokenBalance.decimals).toNumber(), (0, number_1.normalizeValue)(paymentTokenBalance === null || paymentTokenBalance === void 0 ? void 0 : paymentTokenBalance.balance, paymentTokenBalance === null || paymentTokenBalance === void 0 ? void 0 : paymentTokenBalance.decimals).toNumber(), commonTranslator, Boolean(lastBid === null || lastBid === void 0 ? void 0 : lastBid.amount)),
        submit: (form, validationResults) => __awaiter(void 0, void 0, void 0, function* () {
            if (validationResults.isValid) {
                setIsBiddingProcess(true);
                try {
                    const { blockNumber } = (yield sendBid((0, number_1.denormalizeValue)(form.bid, paymentTokenBalance === null || paymentTokenBalance === void 0 ? void 0 : paymentTokenBalance.decimals))) || {};
                    waitBlock(blockNumber);
                }
                catch (error) {
                    console.error(error);
                    setIsBiddingProcess(false);
                }
            }
        }),
    });
    const isApproveInProgress = approvalState === approve_hooks_1.ApprovalState.Unknown || approvalState === approve_hooks_1.ApprovalState.Pending;
    const isApproved = approvalState === approve_hooks_1.ApprovalState.Approved;
    return (React.createElement("div", { className: "c-token-page-auction-bid-form" },
        React.createElement(currency_input_1.CurrencyInput, { label: translator("bidLabel"), placeholder: translator("bidPlaceholder"), value: form.bid, onChange: fieldHandlers.bid, currencySymbol: paymentTokenBalance === null || paymentTokenBalance === void 0 ? void 0 : paymentTokenBalance.symbol, error: validationResults.results.bid, decimals: 2 }),
        React.createElement("div", { className: "c-token-page-auction-bid-form__bid-controls" },
            React.createElement(button_1.Button, { loading: isApproveInProgress && isIdentified, type: "thirtery", disabled: isApproved || isApproveInProgress || !allowToBid, size: "small", onClick: approveCallback }, commonTranslator("approveButton")),
            React.createElement(button_1.Button, { size: "small", loading: isBiddingProcess, disabled: isBiddingProcess || !isApproved || !allowToBid, onClick: placeBid }, translator("bidButton")))));
};
exports.AuctionBidForm = AuctionBidForm;
